import { memo, useEffect, useState } from 'react';
import { CompactPicker } from 'react-color';

import { Card, Flex, Form, Input, InputNumber } from 'antd';

import equal from 'fast-deep-equal';

import { UNIT } from '../../constants/common';
import messages from '../../constants/messages';

import './styles.css';

const { TextArea } = Input;

function GeofenceEditForm({
  circumference = 0,
  color,
  defaultName,
  description,
  carrying_capacity,
  forage_species,
  farmId,
  formRef,
  isMaster = false,
  name,
  size = 0,
  handleColorChange,
  onChange,
  setSubmittable
}) {
  const [form] = Form.useForm();

  const [currentColor, setCurrentColor] = useState();
  const [initialFormValues, setInitialFormValues] = useState({});

  if (formRef) formRef.current = form;

  const values = Form.useWatch([], form);

  useEffect(() => {
    const initial = form.getFieldsValue(true);
    setInitialFormValues(initial);
  }, []);

  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setSubmittable(true))
      .catch(() => setSubmittable(false));
  }, [values]);

  useEffect(() => {
    form.setFieldsValue({ farmId, size, circumference });
  }, [farmId, size, circumference]);

  useEffect(() => {
    if (color) setCurrentColor(color);
  }, [color]);

  function changeCurrentColor({ hex }) {
    setCurrentColor(hex);
    handleColorChange(hex);
  }

  function handleChange() {
    const current = form.getFieldsValue();
    const isSame = equal(current, initialFormValues);

    onChange?.(!isSame);
  }

  const regex = new RegExp(`\\s?${UNIT.STOCK_RATE}`, 'g');

  return (
    <Card title={name ? `Pasture ${name} Details` : 'Pasture Details'} className="mb-2">
      <Form
        autoComplete="off"
        className="geofence-edit-form"
        name="basic"
        form={form}
        initialValues={{
          name: defaultName,
          description,
          farmId,
          size,
          circumference,
          carrying_capacity,
          forage_species
        }}
        labelCol={{ span: 4 }}
        requiredMark={!isMaster}
        onValuesChange={handleChange}>
        <Flex vertical={true} gap="small">
          <Form.Item
            label="Pasture Name"
            name="name"
            colon={false}
            labelAlign="left"
            rules={[
              {
                required: true,
                message: messages.DATA_REQUIRED
              }
            ]}>
            <Input disabled={isMaster} />
          </Form.Item>

          <Form.Item label="Size (ha)" name="size" colon={false} labelAlign="left">
            <Input disabled readOnly />
          </Form.Item>

          <Form.Item label="Perimeter (km)" name="circumference" colon={false} labelAlign="left">
            <Input disabled readOnly />
          </Form.Item>

          <Form.Item label="Carrying capacity" name="carrying_capacity" colon={false} labelAlign="left">
            <InputNumber
              changeOnWheel
              className="w-full"
              min={0}
              formatter={value => `${value || 0} ${UNIT.STOCK_RATE}`}
              parser={value => value.replace(regex, '')}
            />
          </Form.Item>

          <Form.Item label="Description" name="description" colon={false} labelAlign="left">
            <TextArea className="textarea" />
          </Form.Item>

          <Form.Item label="Pasture Color" labelAlign="left" name="color" colon={false}>
            <CompactPicker name="colour" color={currentColor} onChange={changeCurrentColor} />
          </Form.Item>
        </Flex>
      </Form>
    </Card>
  );
}

export default memo(GeofenceEditForm);
